import styled from 'styled-components';
import { screenXsMax, screenSmMin } from '@spotify-internal/encore-foundation';
export default styled.div.withConfig({
  displayName: "FooterNav",
  componentId: "sc-1bnk6zy-0"
})(["@media (max-width:", "){left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);}@media (min-width:", "){display:none;}"], screenXsMax, screenSmMin);